import SimpleBar from "simplebar-react";
import React, { useState } from "react";
import "../../../settings.styles.css";
import "./eventMenuTemplates.style.css";
import ClickOutside from "../../../../../Components/Common/ClickOutsideComponent";
import { Col, Row } from "reactstrap";
const EventMenuTemplates = () => {
  const initialData = {
    menuTitle: "Menu Title",
    menuTitleEditActive: false,
  };
  const [createUpdateMenu, setCreateUpdateMenu] = useState(initialData);
  const [menuItems, setMenuItems] = useState([]);

  return (
    <div>
      <div className={"settings-page-main-frame"}>
        <div className="settings-page-left-side  add-right-side-border">
          <div className="p-0 ps-4 pe-4 d-flex flex-column h-100">
            <SimpleBar className="mx-n4 px-4  " data-simplebar>
              <div className="mail-list mt-3">Menu Items</div>
              <div className={"food-menu-items-selection"}>
                <div>
                  <div>
                    <h6>Startes</h6>
                  </div>
                  <div className={"ps-1"}>
                    <div>
                      <span>Oisters soup</span>
                    </div>
                    <div>
                      <span>Onion salad</span>
                    </div>
                    <div>
                      <span>Caramelised Cheese</span>
                    </div>
                  </div>
                </div>
                <div className={"pt-2"}>
                  <div>
                    <h6>Mains</h6>
                  </div>
                  <div className={"ps-1"}>
                    <div>
                      <span>8oz Rump Steak</span>
                    </div>
                    <div>
                      <span>Tagiteli risoto</span>
                    </div>
                    <div>
                      <span>Fish & Chips</span>
                    </div>
                    <div>
                      <span>6oz Beef Burger</span>
                    </div>
                  </div>
                </div>
                <div className={"pt-2"}>
                  <div>
                    <h6>Sides</h6>
                  </div>
                  <div className={"ps-1"}>
                    <div>
                      <span>Bacon and Cheese Chips</span>
                    </div>
                    <div>
                      <span>Chilli Cheese bites</span>
                    </div>
                    <div>
                      <span>Salad</span>
                    </div>
                  </div>
                </div>
                <div className={"pt-2"}>
                  <div>
                    <h6>Deserts</h6>
                  </div>
                  <div className={"ps-1"}>
                    <div>
                      <span>Black Forest</span>
                    </div>
                    <div>
                      <span>Apple Pie</span>
                    </div>
                    <div>
                      <span>Cheese and biscuit</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="pb-4 border-bottom border-bottom-dashed"></div>
            </SimpleBar>
          </div>
        </div>
        <div className="settings-page-content-right-side">
          <SimpleBar className="message-list-content mx-n4 px-4 message-list-scroll">
            <div className={"p-2"}>
              <div className={"food-menu-main-header"}>
                {createUpdateMenu?.menuTitleEditActive ? (
                  <div>
                    <input
                      className={"form-control text-center"}
                      autoFocus={true}
                      type={"text"}
                      value={createUpdateMenu?.menuTitle}
                      onChange={(e) => {
                        setCreateUpdateMenu({
                          ...createUpdateMenu,
                          menuTitle: e.target.value,
                        });
                      }}
                      onBlur={() => {
                        setCreateUpdateMenu({
                          ...createUpdateMenu,
                          menuTitleEditActive: false,
                        });
                      }}
                    />
                  </div>
                ) : (
                  <span
                    onClick={() => {
                      setCreateUpdateMenu({
                        ...createUpdateMenu,
                        menuTitleEditActive: true,
                      });
                    }}
                    className={"h5 cursor-pointer"}
                  >
                    {createUpdateMenu?.menuTitle}
                  </span>
                )}
              </div>
              <div className={"menu-content-body"}>
                <Row>
                  <Col lg={4}>
                    <div>
                      <div className={"menu-food-subheader"}>
                        <h6>Starter</h6>
                      </div>
                      <div className={"menu-food-items"}>
                        <div className={"menu-food-item-name"}>
                          Garlic Bread
                        </div>
                        <div
                          className={
                            "menu-food-item-description text-muted text-center"
                          }
                        >
                          <p>
                            Garlic Bread (VG){" "}
                            <span className={"fw-light"}>465kcal</span> £3.50
                          </p>
                        </div>
                      </div>
                      <div className={"menu-food-items"}>
                        <div className={"menu-food-item-name"}>
                          Yellowfin tuna tarter
                        </div>
                        <div
                          className={
                            "menu-food-item-description text-muted text-center"
                          }
                        >
                          <p>
                            Yellowfin tuna tarter with avocado, cucumber,
                            sesame, soy and dressing (GF){" "}
                            <span className={"fw-light"}>1465kcal</span> £13.50
                          </p>
                        </div>
                      </div>
                      <div className={"menu-food-items"}>
                        <div className={"menu-food-item-name"}>
                          Soup of the day
                        </div>
                        <div
                          className={
                            "menu-food-item-description text-muted text-center"
                          }
                        >
                          <p>
                            Soup of the day with avocado, cucumber, sesame, soy
                            and dressing (GF){" "}
                            <span className={"fw-light"}>1465kcal</span> £13.50
                          </p>
                        </div>
                      </div>
                    </div>
                  </Col>
                  <Col lg={4}>
                    {" "}
                    <div>
                      <div className={"menu-food-subheader"}>
                        <h6>Mains</h6>
                      </div>
                      <div className={"menu-food-items"}>
                        <div className={"menu-food-item-name"}>
                          Red Shrimp rigatoni alla vadka
                        </div>
                        <div
                          className={
                            "menu-food-item-description text-muted text-center"
                          }
                        >
                          <p>
                            Red Shrimp rigatoni alla vadka , red prawans,
                            tomato, chilli, garlic, parsley, cream and vodka
                            (GF) <span className={"fw-light"}>1265kcal</span>{" "}
                            £14.39
                          </p>
                        </div>
                      </div>
                      <div className={"menu-food-items"}>
                        <div className={"menu-food-item-name"}>
                          Grilled swordfish steak
                        </div>
                        <div
                          className={
                            "menu-food-item-description text-muted text-center"
                          }
                        >
                          <p>
                            Grilled swordfish steak with sauteed potatoes, green
                            beans and salsa verde (GF){" "}
                            <span className={"fw-light"}>845kcal</span> £15.39
                          </p>
                        </div>
                      </div>
                      <div className={"menu-food-items"}>
                        <div className={"menu-food-item-name"}>
                          Lobster Roll
                        </div>
                        <div
                          className={
                            "menu-food-item-description text-muted text-center"
                          }
                        >
                          <p>
                            Lobster Roll with sauteed potatoes, green beans and
                            salsa verde (GF){" "}
                            <span className={"fw-light"}>945kcal</span> £12.39
                          </p>
                        </div>
                      </div>
                    </div>
                  </Col>
                  <Col lg={4}>
                    <div>
                      <div className={"menu-food-subheader"}>
                        <h6>Sides</h6>
                      </div>
                      <div className={"menu-food-items"}>
                        <div className={"menu-food-item-name"}>Onion Rings</div>
                        <div
                          className={
                            "menu-food-item-description text-muted text-center"
                          }
                        >
                          <p>
                            Onion Rings (VG){" "}
                            <span className={"fw-light"}>365kcal</span> £3.39
                          </p>
                        </div>
                      </div>
                      <div className={"menu-food-items"}>
                        <div className={"menu-food-item-name"}>
                          Cheesy fries
                        </div>
                        <div
                          className={
                            "menu-food-item-description text-muted text-center"
                          }
                        >
                          <p>
                            Cheesy fries with sauteed potatoes, green beans and
                            salsa verde (GF){" "}
                            <span className={"fw-light"}>645kcal</span> £5.39
                          </p>
                        </div>
                      </div>
                      <div className={"menu-food-items"}>
                        <div className={"menu-food-item-name"}>
                          Spring Rolls
                        </div>
                        <div
                          className={
                            "menu-food-item-description text-muted text-center"
                          }
                        >
                          <p>
                            Spring Rolls with sauteed potatoes, green beans and
                            salsa verde (GF){" "}
                            <span className={"fw-light"}>345kcal</span> £2.39
                          </p>
                        </div>
                      </div>
                      <div className={"menu-food-subheader"}>
                        <h6>Deserts</h6>
                      </div>
                      <div className={"menu-food-items"}>
                        <div className={"menu-food-item-name"}>Gelato</div>
                        <div
                          className={
                            "menu-food-item-description text-muted text-center"
                          }
                        >
                          <p>
                            Gelato flavors include: Vanilla, Chocolate,
                            Strawberry, Pistachio, Hazelnut, Coffee, Lemon,
                            Mango, Raspberry, Coconut, Mint, Caramel, Banana,
                            Tiramisu, Cookies & Cream, and more.
                            <span className={"fw-light"}>145kcal</span> £1.39
                            per scope.
                          </p>
                        </div>
                      </div>
                      <div className={"menu-food-items"}>
                        <div className={"menu-food-item-name"}>
                          Raspberry Tart
                        </div>
                        <div
                          className={
                            "menu-food-item-description text-muted text-center"
                          }
                        >
                          <p>
                            Raspberry Tart flavors include: Vanilla, Chocolate,
                            Strawberry, Pistachio, Hazelnut, Coffee, Lemon
                            <span className={"fw-light"}>1145kcal</span> £21.39
                          </p>
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </SimpleBar>
        </div>
      </div>
    </div>
  );
};

export default EventMenuTemplates;
